<template>
  <Upload-File />
</template>

<script>

import UploadFile from '@/components/helpers/UploadFile'

export default {
  name: 'Test',
  components: { UploadFile }
}
</script>

<style>

</style>